var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-bottom":"20px"}},[_c('el-pagination',{attrs:{"background":"","layout":"total, prev, pager, next","total":_vm.pageTotle},on:{"current-change":_vm.handleCurrentChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }